import React from "react";
import "./Testimonial.css";
import testimonial1 from "../../assets/testimonial1.png.webp";
import testimonial2 from "../../assets/testimonial2.png.webp";
import testimonial3 from "../../assets/testimonial3.png.webp";

interface Testimonial {
  name: string;
  feedback: string;
  position: string;
  image: string;
}

const TestimonialSection: React.FC = () => {
  const testimonials: Testimonial[] = [
    {
      name: "Phenome Pathirana",
      position: "Phenomenal Trading Company - Colombo",
      feedback:
        "We’ve been selling Bixton LED Bulbs for years, and their excellent product quality and support have been key to our strong association.",
      image: testimonial1,
    },
    {
      name: "Mohomed Ismath Rahuman",
      position: "Negombo Sales Center - Negombo",
      feedback:
        "Bixton LED Bulbs are reliable and come with a quality guarantee, giving both us and our customers complete peace of mind.",
      image: testimonial2,
    },
    {
      name: "Lalith Premasiri",
      position: "Kochchikade Electricals - Kochchikade",
      feedback:
        "Bixton LED lights are high-quality products that I can responsibly offer to my customers at a reasonable price.",
      image: testimonial3,
    },
  ];

  return (
    <section className="testimonial-section">
      <h2 className="testimonial-title">What people say</h2>

      <div className="testimonial-cards">
        {testimonials.map((testimonial, index) => (
          <div className="testimonial-card" key={index}>
            <img loading="lazy" decoding="async"
              src={testimonial.image}
              alt={testimonial.name}
              className="testimonial-avatar"
            />

            <p className="testimonial-feedback">{testimonial.feedback}</p>

            <p className="testimonial-name">
              {testimonial.name}
              <br />
              <span className="testimonial-position">{testimonial.position}</span>
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialSection;
